<footer class="footer relative z-[99] bg-white">
	<div class="md:flex md:items-center md:justify-between">
		<div class="text-xs text-grey-60 sm:text-center">
			<span>
				<img class="mr-1 inline-block" src="/assets/copyright-icon.svg" />
			</span>
			<span>This site is for AirAsia internal use only</span>
		</div>

	</div>
</footer>
